import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const BrowsersIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-browsers"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M48,4 L16,4 C14.3427153,4 13,5.34271525 13,7 L13,31 C13,32.6572847 14.3427153,34 16,34 L48,34 C49.6572847,34 51,32.6572847 51,31 L51,7 C51,5.34271525 49.6572847,4 48,4 Z M16,6 L48,6 C48.5527153,6 49,6.44728475 49,7 L49,31 C49,31.5527153 48.5527153,32 48,32 L16,32 C15.4472847,32 15,31.5527153 15,31 L15,7 C15,6.44728475 15.4472847,6 16,6 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M52,0 C53.598096,0 54.9036905,1.24851967 54.9949089,2.82368432 L55,3 L55,27 C55,28.598096 53.7514803,29.9036905 52.1763157,29.9949089 L52,30 L52,28 C52.5132356,28 52.9355643,27.614331 52.9932784,27.1167007 L53,27 L53,3 C53,2.48676441 52.614331,2.06443573 52.1167007,2.00672161 L52,2 L20,2 C19.4867644,2 19.0644357,2.38566899 19.0067216,2.88329933 L19,3 L17,3 C17,1.40190399 18.2485197,0.0963094688 19.8236843,0.00509110492 L20,0 L52,0 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M18,8 C18,8.552 17.552,9 17,9 C16.448,9 16,8.552 16,8 C16,7.448 16.448,7 17,7 C17.552,7 18,7.448 18,8"
          fill="#00000"
          className={styles.defaultColor}
        />
        <polygon fill="#00000" className={styles.defaultColor} points="15 11 49 11 49 10 15 10" />
        <polygon fill="#00000" className={styles.defaultColor} points="25 9 49 9 49 8 25 8" />
        <polygon fill="#00000" className={styles.defaultColor} points="25 8 26 8 26 6 25 6" />
        <polygon fill="#00000" className={styles.defaultColor} points="28 8 29 8 29 6 28 6" />
        <polygon fill="#00000" className={styles.defaultColor} points="31 8 32 8 32 6 31 6" />
        <polygon fill="#00000" className={styles.defaultColor} points="34 8 35 8 35 6 34 6" />
        <polygon fill="#00000" className={styles.defaultColor} points="37 8 38 8 38 6 37 6" />
        <polygon fill="#00000" className={styles.defaultColor} points="40 8 41 8 41 6 40 6" />
        <polygon fill="#00000" className={styles.defaultColor} points="43 8 44 8 44 6 43 6" />
        <polygon fill="#00000" className={styles.defaultColor} points="46 8 47 8 47 6 46 6" />
        <path
          d="M21 8C21 8.552 20.552 9 20 9 19.448 9 19 8.552 19 8 19 7.448 19.448 7 20 7 20.552 7 21 7.448 21 8M24 8C24 8.552 23.552 9 23 9 22.448 9 22 8.552 22 8 22 7.448 22.448 7 23 7 23.552 7 24 7.448 24 8"
          fill="#00000"
          className={styles.defaultColor}
        />
        <path
          d="M32,13 C27.5817153,13 24,16.5817153 24,21 C24,25.4182847 27.5817153,29 32,29 C36.4182847,29 40,25.4182847 40,21 C40,16.5817153 36.4182847,13 32,13 Z M32,15 C35.3137153,15 38,17.6862847 38,21 C38,24.3137153 35.3137153,27 32,27 C28.6862847,27 26,24.3137153 26,21 C26,17.6862847 28.6862847,15 32,15 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
        />
        <path
          d="M31.5625,13 C33.8322648,13 35.1875,16.6141982 35.1875,21 C35.1875,25.2883396 33.8918283,28.8389879 31.712458,28.9946768 L31.5625,29 L31.5625,27 C32.1925625,27 33.1875,24.3466587 33.1875,21 C33.1875,17.7517724 32.2502275,15.1566787 31.6190061,15.006836 L31.5625,15 L31.5625,13 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          points="38.563 20 38.563 22 25.438 22 25.438 20"
        />
        <path
          d="M32.4375,13 L32.4375,15 C31.8074375,15 30.8125,17.6533413 30.8125,21 C30.8125,24.2482276 31.7497725,26.8433213 32.3809939,26.993164 L32.4375,27 L32.4375,29 C30.1677352,29 28.8125,25.3858018 28.8125,21 C28.8125,16.7116604 30.1081717,13.1610121 32.287542,13.0053232 L32.4375,13 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
